import { render, staticRenderFns } from "./employeeUserTrainingPDF.vue?vue&type=template&id=ed2fdfcc"
import script from "./employeeUserTrainingPDF.vue?vue&type=script&lang=js"
export * from "./employeeUserTrainingPDF.vue?vue&type=script&lang=js"
import style0 from "./employeeUserTrainingPDF.vue?vue&type=style&index=0&id=ed2fdfcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports